angular.module('picmonicng').directive('clickOnEnter', [
  function () {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        element.bind('keydown', function (e) {
          var code = e.keyCode || e.which;
          if (code === 13) {
            element.click();
          }
        });
      },
    };
  },
]);
